export const tallyTypes = {
  etiology: "etiology",
  location: "location",
  total: "total"
};
